export default "__VITE_ASSET__D8tKS4mC__"